import {memo, useEffect} from 'react'
import type {ProgressiveDiffEntry} from '../../types/progressive-diff-types'
import {DiffEntryLoadingSkeleton} from './DiffEntryLoadingSkeleton'
import {useProgressiveDiffActions} from '../../stores/selectors'
import {useFeatureFlag} from '@github-ui/react-core/use-feature-flag'

export const EagerDiffEntryLoadingSkeleton = memo(function EagerDiffEntryLoadingSkeleton({
  progressiveDiffEntry,
  approximateLineCount = 5,
}: {
  progressiveDiffEntry: ProgressiveDiffEntry
  approximateLineCount?: number
}) {
  const {loadMore} = useProgressiveDiffActions()
  const skipPreferAnySoloEntry = useFeatureFlag('pulls-files-skip-prefer-any-solo-entry')

  useEffect(() => {
    loadMore(progressiveDiffEntry, {preferAnySoloEntry: !skipPreferAnySoloEntry})
  }, [loadMore, progressiveDiffEntry, skipPreferAnySoloEntry])

  return (
    <DiffEntryLoadingSkeleton
      ariaLabel={`Loading ${progressiveDiffEntry.path}`}
      testId={`eager-load-${progressiveDiffEntry.path}`}
      id={`diff-${progressiveDiffEntry.pathDigest}`}
      approximateLineCount={approximateLineCount}
    />
  )
})

try{ EagerDiffEntryLoadingSkeleton.displayName ||= 'EagerDiffEntryLoadingSkeleton' } catch {}